var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftOutlined = function SvgGiftOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#giftOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#giftOutlined_svg__b)",
    d: "M19.412 6.603h-2.2c.25-.42.4-.9.4-1.42a2.3 2.3 0 0 0-2.3-2.3h-.32c-1.23 0-2.32.61-2.99 1.54a3.68 3.68 0 0 0-2.99-1.54h-.32a2.3 2.3 0 0 0-2.3 2.3c0 .52.15 1 .4 1.42h-2.24c-.85 0-1.54.69-1.54 1.54v1.72c0 .78.58 1.42 1.34 1.52v7.34c0 1.28 1.04 2.31 2.31 2.31h10.73c1.28 0 2.31-1.04 2.31-2.31v-7.35c.71-.14 1.25-.76 1.25-1.51v-1.72c0-.85-.69-1.54-1.54-1.54m0 1.4c.08 0 .14.06.14.14v1.72c0 .08-.06.14-.14.14h-4.9v-2zm-4.42-3.72h.32c.5 0 .9.4.9.9 0 .77-.62 1.39-1.39 1.39h-2.12a2.29 2.29 0 0 1 2.29-2.29m-6.3 0h.32a2.29 2.29 0 0 1 2.29 2.29h-2.12c-.77 0-1.39-.62-1.39-1.39 0-.5.4-.9.9-.9m-4.28 3.86c0-.08.06-.14.14-.14h4.94v2h-4.94c-.08 0-.14-.06-.14-.14zm5.08 11.5h-2.83c-.5 0-.91-.41-.91-.91v-7.32h3.74v8.24zm3.61 0h-2.21V8.373h2.21zm5.2-.91c0 .5-.41.91-.91.91h-2.89v-8.24h3.8v7.33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "giftOutlined_svg__b",
    x1: 3.395,
    x2: 20.36,
    y1: 21.033,
    y2: 20.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "giftOutlined_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGiftOutlined;